'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Folder, ClipboardList } from 'lucide-react';
import { NavLink } from '@/shared/lib/navigation';
import { useNamespacedTranslate } from '@/shared/lib/locales';

export function Sidebar({ navLinks }: { navLinks: NavLink[] }) {
  const t = useNamespacedTranslate('sidebar');

  const pathname = usePathname();

  return (
    <aside className="flex w-48 flex-col border-r border-gray-200 bg-white">
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navLinks.map((link) => {
          const isActive = pathname === link.href;
          const iconClasses = "h-5 w-5 text-gray-500 mr-2 " + (isActive ? 'text-blue-500' : 'text-gray-500');
          const icon = link.icon == 'home'?
            <Folder className={iconClasses} />
            :
            <ClipboardList className={iconClasses} />;
          return (
            <Link
              key={link.href}
              href={link.href}
              className={`flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
            >
              {icon}
              {t(link.nameKey)}
            </Link>
          );
        })}
      </nav>

      <div className="border-t border-gray-100 px-4 py-3">
        <p className="text-xs text-gray-400">{t('stackCaption')}</p>
      </div>
    </aside>
  );
}
